import React, {Component} from 'react';
import Helmet from 'react-helmet';

class Logout extends Component {

  componentDidMount() {

    // GA計測用データレイヤースクリプトを追加する
    window.addDataLayerScript('jmbauth_logout');
  }

  render() {
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    return (
      <section className="content">
        <Helmet
          title={messageList.logout.M001_browserTitle} >
        </Helmet>

        <div className="ds-heading ds-heading--lg">
          <h1 className="ds-heading__title">{messageList.logout.M002_pageTitle}</h1>
        </div>

        <div className="contentInner">
          <p className="ds-text">{messageList.logout.M003_message}</p>
        </div>
        <hr className="hr hr--large" />

        <div className="contentInner" id="JS_countryLangBox">
          <div id="WA_countryList">
            <p className="ds-text u-al-center">{messageList.logout.M004_selectCityLang001}{messageList.logout.M005_selectCityLang002}</p>
          </div>
          <div className="formWrap formWrap--center">
            <div className="ds-select">
              <select id="JS_countryList" className="ds-select__field" aria-labelledby="WA_countryList">
              </select>
            </div>
          </div>

          <fieldset>
            <legend className="u-screenOnly">言語</legend>
            <ul className="formRadioList formRadioList--flex formRadioList--center" data-content="JS_langSelect">
              <li className="formRadioList__item is-hide">
                <label className="ds-radio">
                  <input className="ds-radio__input" type="radio" name="class-radio" data-lang="lc" />
                  <span className="ds-radio__partsWrap">
                    <span className="ds-radio__parts" role="none"></span>
                    <span className="ds-radio__text JS_langSelectItemText">多言語</span>
                  </span>
                </label>
              </li>
              <li className="formRadioList__item">
                <label className="ds-radio">
                  <input className="ds-radio__input" type="radio" name="class-radio" data-lang="ja" defaultChecked />
                  <span className="ds-radio__partsWrap">
                    <span className="ds-radio__parts" role="none"></span>
                    <span className="ds-radio__text JS_langSelectItemText">日本語</span>
                  </span>
                </label>
              </li>
              <li className="formRadioList__item">
                <label className="ds-radio">
                  <input className="ds-radio__input" type="radio" name="class-radio" data-lang="en" />
                  <span className="ds-radio__partsWrap">
                    <span className="ds-radio__parts" role="none"></span>
                    <span className="ds-radio__text JS_langSelectItemText">English</span>
                  </span>
                </label>
              </li>
            </ul>
          </fieldset>

          <div className="buttonLayout">
            <div className="buttonWrap buttonWrap--center">
              <div className="ds-button ds-button--tertiary ds-button--large">
                <button className="ds-button__trigger" type="button" data-btn="JS_continue">
                  <span className="ds-button__label">{messageList.logout.M006_home}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Logout
